import React from 'react';

export default function DMCAPolicy() {
  return (
    <div className="bg-white min-h-screen flex flex-col py-10 px-2">
      <div className="max-w-3xl mx-auto bg-white rounded-xl shadow-xl border border-gray-200 p-8">

        {/* Header */}
        <div className="text-center mb-8">
          <h1 className="text-3xl text-center md:text-4xl font-extrabold text-blue-900 mb-2">
            DMCA Copyright Infringement Policy
          </h1>
          <p className="text-lg text-gray-700">
            Million2Trillion fully respects intellectual property rights and strictly follows U.S. Digital Millennium Copyright Act (DMCA) standards for takedown requests.
          </p>
        </div>

        {/* Policy Content */}
        <div className="border border-purple-200 bg-purple-50 p-6 rounded-2xl shadow mb-10 space-y-6 text-gray-700 text-base">
          <p>
            If you believe that any content hosted, published, or shared within Million2Trillion infringes your valid copyright or intellectual property rights, you may submit a DMCA takedown notice to our legal team for immediate review.
          </p>

          <h2 className="text-2xl font-bold text-purple-600">Submitting A Valid DMCA Notice</h2>
          <ul className="list-disc space-y-3 pl-6">
            <li>Clear identification of the copyrighted work you claim is infringed.</li>
            <li>Specific URL(s) or location of the allegedly infringing content inside Million2Trillion platform.</li>
            <li>Full name, mailing address, telephone number, and email address of the complaining party.</li>
            <li>Statement under penalty of perjury that you have a good-faith belief that use of the copyrighted material is not authorized.</li>
            <li>Signed physical or electronic signature of the copyright owner or authorized agent.</li>
          </ul>

          <h2 className="text-2xl font-bold text-purple-600">Submit DMCA Notices To:</h2>
          <p>
            Million2Trillion Global Technologies<br />
            Attn: DMCA Legal Department<br />
            Email: <a href="mailto:legal@million2trillion.com" className="text-blue-700 underline">legal@million2trillion.com</a><br />
            (Official address will be added after full company registration.)
          </p>

          <h2 className="text-2xl font-bold text-purple-600">Counter-Notice &amp; Response</h2>
          <ul className="list-disc space-y-3 pl-6">
            <li>The content uploader may submit a counter-notice if they believe the takedown request was filed in error or misrepresentation.</li>
            <li>M2T will review counter-notices before restoring any removed content.</li>
            <li>Repeat copyright offenders may face permanent suspension and legal consequences.</li>
          </ul>

          <p>
            Million2Trillion fully cooperates with global law enforcement, IP holders, regulatory bodies, and legal authorities for any copyright violations.
          </p>
        </div>

      </div>
    </div>
  );
}
